import { render } from "./SaleDetails.vue?vue&type=template&id=5b14f85b&scoped=true"
import script from "./SaleDetails.vue?vue&type=script&lang=js"
export * from "./SaleDetails.vue?vue&type=script&lang=js"

import "./SaleDetails.vue?vue&type=style&index=0&id=5b14f85b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b14f85b"]])

export default __exports__